const DOUYIN_HOSTS = ["douyin.com", "iesdouyin.com"];
const XHS_HOSTS = ["xiaohongshu.com", "xhslink.com"];

function belongsTo(hostname: string, domains: string[]): boolean {
  return domains.some(
    (domain) => hostname === domain || hostname.endsWith(`.${domain}`)
  );
}

export function extractSupportedSocialUrl(text: string): string | undefined {
  const matches = text.match(/https?:\/\/[^\s<>"']+/gi) ?? [];
  for (const match of matches) {
    const candidate = match.replace(/[，。；、）)\]}]+$/g, "");
    try {
      const url = new URL(candidate);
      if (
        (url.protocol === "https:" || url.protocol === "http:") &&
        (belongsTo(url.hostname, DOUYIN_HOSTS) ||
          belongsTo(url.hostname, XHS_HOSTS))
      ) {
        return url.toString();
      }
    } catch {
      // Ignore malformed share text.
    }
  }
  return undefined;
}

export function socialPlatformLabel(text: string): "抖音" | "小红书" | undefined {
  const url = extractSupportedSocialUrl(text);
  if (!url) return undefined;
  const hostname = new URL(url).hostname;
  return belongsTo(hostname, DOUYIN_HOSTS) ? "抖音" : "小红书";
}
